// Server-side analytics that doesn't require cookie consent
// This tracks essential business metrics without using cookies

const ANALYTICS_ENDPOINT = process.env.REACT_APP_ANALYTICS_ENDPOINT || 'https://your-analytics-api.com/track';

/**
 * Send analytics data to your own server/database
 * This doesn't require cookie consent as it uses session-based tracking
 */
export const trackServerSideEvent = async (eventData) => {
  try {
    // Skip if endpoint is not configured
    if (ANALYTICS_ENDPOINT.includes('your-analytics-api.com')) {
      console.log('Server-side analytics (demo mode):', eventData);
      return;
    }

    const payload = {
      ...eventData,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      referrer: document.referrer || 'direct',
      userAgent: navigator.userAgent,
      sessionId: getSessionId(), // Session-based, not cookie-based
      // Don't track IP on client side - let server handle it
    };

    // Send to your own analytics endpoint
    await fetch(ANALYTICS_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.warn('Server-side analytics failed:', error);
  }
};

/**
 * Generate session ID using sessionStorage (not localStorage)
 * This doesn't require cookie consent
 */
function getSessionId() {
  let sessionId = sessionStorage.getItem('analytics_session');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    sessionStorage.setItem('analytics_session', sessionId);
  }
  return sessionId;
}

/**
 * Track page views without cookies
 */
export const trackPageViewServerSide = (pageTitle, additionalData = {}) => {
  trackServerSideEvent({
    event: 'page_view',
    page_title: pageTitle,
    page_path: window.location.pathname,
    page_search: window.location.search,
    ...additionalData
  });
};

/**
 * Track button clicks for ad campaigns
 */
export const trackButtonClickServerSide = (buttonName, campaign, additionalData = {}) => {
  trackServerSideEvent({
    event: 'button_click',
    button_name: buttonName,
    campaign: campaign,
    ...additionalData
  });
};

/**
 * Track ad campaign performance without cookies
 */
export const trackAdCampaignServerSide = (campaignId, source, medium, additionalData = {}) => {
  trackServerSideEvent({
    event: 'ad_campaign',
    campaign_id: campaignId,
    utm_source: source,
    utm_medium: medium,
    ...additionalData
  });
};

/**
 * Track conversions for ad platforms
 */
export const trackConversionServerSide = (conversionType, value, currency = 'CAD', additionalData = {}) => {
  trackServerSideEvent({
    event: 'conversion',
    conversion_type: conversionType,
    value: value,
    currency: currency,
    ...additionalData
  });
};
